import { Condition } from '@urbanx/agx.campaigns.client';
import { DropdownOption } from '@urbanx/agx.ui-components2';

const baseOption: DropdownOption = { label: '-', value: '' };

const financeOptions: DropdownOption[] = [
  {
    label: 'finance being satisfied',
    value: Condition.FinanceBeingSatisfied,
  },
  {
    label: 'building and pest being satisfied',
    value: Condition.BuildingAndPestBeingSatisfied,
  },
  {
    label: 'satisfaction of special condition',
    value: Condition.UponSatisfactionOfSpecialCondition,
  },
];

export const ConditionFromOptions: DropdownOption[] = [
  baseOption,
  {
    label: 'Contract date',
    value: Condition.NdaysFromDate,
  },
  {
    label: 'specific date',
    value: Condition.OnSpecificDate,
  },
  ...financeOptions,
];

// For "On..." segment in Initial deposits - uses OnDate for contract date
export const InitialDepositOnDateOptions: DropdownOption[] = [
  baseOption,
  {
    label: 'Contract date',
    value: Condition.OnDate,
  },
  {
    label: 'specific date',
    value: Condition.OnSpecificDate,
  },
  ...financeOptions,
];

// For "On..." segment in Balance deposits - uses OnDate for unconditional date
export const BalanceDepositOnDateOptions: DropdownOption[] = [
  baseOption,
  {
    label: 'Unconditional date',
    value: Condition.OnDate,
  },
  {
    label: 'specific date',
    value: Condition.OnSpecificDate,
  },
  ...financeOptions,
];

// For "# days from..." segment in Initial deposits
export const InitialDepositNDaysOptions: DropdownOption[] = [
  baseOption,
  {
    label: 'Contract date',
    value: Condition.NdaysFromDate,
  },
  ...financeOptions,
];

// For "# days from..." segment in Balance deposits
export const BalanceDepositNDaysOptions: DropdownOption[] = [
  baseOption,
  {
    label: 'Unconditional date',
    value: Condition.NdaysFromDate,
  },
  ...financeOptions,
];
